import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/category/:idOrSlug -> single category, with isLeaf + ancestors
// (root-first) for breadcrumb rendering and canonical-URL resolution.
export default function useCategory(idOrSlug) {
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idOrSlug) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    setLoading(true);
    client
      .get(`/category/${idOrSlug}`)
      .then(({ data }) => {
        if (!active) return;
        setCategory(data);
        setError(null);
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setCategory(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [idOrSlug]);

  return { category, loading, error };
}
